import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'



Vue.use(Vuex)

const vuexLocalStorage = new VuexPersist({
  key: 'vuex', // The key to store the state on in the storage provider.
  storage: window.localStorage, // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
})

export default new Vuex.Store({
  state: {
    email: null,
    questions:
      [
        {
          name: "Scope",
          questionSet: {
            Q1: {
              question: {
                type: "bool",
                question: "Do you maintain a list of all assets for company issued devices?",
                options: ["Yes", "No"]
              },
              Answer: null,
              RecTriggerAnswer: "No",
              Recommendation: "An important part of maintaining the security of your organisation is to understand what software is installed and running on your organisation assets.  Software can become unnecessary, outdated, unsupported, or affected by a series of vulnerabilities. Ensuring a log of both devices and software in use throughout your organisation can help to inform your decisions on patch management and regularly reviewing the security of your devices."
            },
            Q2: {
              question: {
                type: "bool",
                question: "Do you mainatain a log of all personal, BYOD, devices with access to company resources and data?",
                options: ["Yes", "No"]
              },
              Answer: null,
              RecTriggerAnswer: "No",
              Recommendation: "Personal Devices, or Bring Your Own Devices, BYOD's, can allow flexibility and ease of use for your staff members, especially when working from home, or for quick access to information on there phone.  However, allowing any devcies to access your company data and resources does open up a number of potential security risks.  As you may have no ability to control the devices which can connect, the configuration of the device or the software installed on the devices, allowing BYOD's into your organisation could allow in an already compromised device.  This could result in account compromise and data breaches.  The best approach to BYOD's can often be to not allow them to access organisation data.  If however BYODs are to be allowed access, they need to maintain the same baseline security standard as any other device within your organisation.Maintaining a Device Management solution can allow you to enforce technical controls onto any devices which request access to your organisation resources and data, and maintaining a Device Policy document stipulating these same controls can help to ensure that only devices which meet these minimum security standards will access your data."
            },
            Q3: {
              question: {
                type: "bool",
                question: "Do you maintain a software inventory for all your devices?",
                options: ["Yes", "No"]
              },
              Answer: null,
              RecTriggerAnswer: "No",
              Recommendation: "An important part of maintaining the security of your organisation is to understand what software is installed and running on your organisation assets.  Software can become unnecessary, outdated, unsupported, or affected by a series of vulnerabilities.  Ensuring a log of both devices and software in use throughout your organisation can help to inform your decisions on patch management and regularly reviewing the security of your devices."
            },
            Q4: {
              question: {
                type: "number",
                question: "How many laptops, desktops, virtual desktops & thin client types do you have?"
              },
              Answer: null,
              CorrectAnswer: null,
              Recommendation: null
            },
            Q5: {
              question: {
                type: "number",
                question: "How many servers/virtual servers do you have?"
              },
              Answer: null,
              CorrectAnswer: null,
              Recommendation: null
            },
            Q6: {
              question: {
                type: "bool",
                question: "Do you make use of any cloud services?",
                options: ["Yes", "No"]
              },
              Answer: null,
              RecTriggerAnswer: "No",
              Recommendation: "Cloud services form a common and fundamental part of most organisations.  Whether this is through services provided via AWS and Azure or just through email access and Microsoft 365.  These solutions need to be maintained and configured in a secure manner similar to any other asset which forms part of your organisation.  Ensure your environments are configured to a secure standard and that your user accounts are suitably protected through solutions such as MFA."
            },

          }
        },
        {
          name: "Boundary Firewalls & Internet Gateways",
          questionSet: {
            Q1: {
              question: {
                type: "bool",
                question: "Do you have firewalls between your network and the internet?",
                options: ["Yes", "No"]
              },
              Answer: null,
              RecTriggerAnswer: "No",
              Recommendation: "Your devices should be secured through the use of a well configured and maintained Firewall.  This may be through the use of a Hardware Firewall or could be a suitably configured software Firewall.  Regardless of the firewall type which is in place, it is important to ensure that it adheres to a number of security standards.  This includes configuring your user accounts to a suitably secure standard, maintaining a change control process for your firewall rules and ensuring that any services which are internet facing have a documented and approved business case."
            },
            Q2: {
              question: {
                type: "text",
                question: "What type of firewall do you have?"
              },
              Answer: null,
              CorrectAnswer: null,
              Recommendation: null
            },
            Q3: {
              question: {
                type: "bool",
                question: "Do you have a firewall change control process?",
                options: ["Yes", "No"]
              },
              Answer: null,
              RecTriggerAnswer: "No",
              Recommendation: "Maintaining a standardised change control process for you firewalls ensures that no unexpected rule changes are configired which may inadvertently open up access to devices and services previously unintended to be accessible.  Any firewall which is in use within your organisation should have a standardised change control process in place which ensures that updates to the configured ruleset are approved in advance before being implemented."
            },
            Q4: {
              question: {
                type: "bool",
                question: "Do you have any public facing services or web applications?",
                options: ["Yes", "No"]
              },
              Answer: null,
              RecTriggerAnswer: "No",
              Recommendation: "Ensure you only enable a minimal set of services to be made publicly accessible.  Where possible only specific services such as a a suitably secured VPN service should be exposed to the internet.  Once devices have authentciated via a remote access solution, such as a VPN, other services which are relevent or required for business purposes can then be made accessible."
            },
            Q5: {
              question: {
                type: "bool",
                question: "Do you have a remote desktop or vdi solution?",
                options: ["Yes", "No"]
              },
              Answer: null,
              RecTriggerAnswer: "No",
              Recommendation: "VDI is a favourite target for hackers and ransomware gangs, ensure you perform bi-anual breakout testing to discover ways that attackers with compromised accounts can take over your network"
            },
            Q6: {
              question: {
                type: "multi",
                question: "Are these services self-hosted, cloud hosted, 3rd party hosted?",
                options: ["Self Hosted", "Cloud Hosted", "Third Party Hosted"]
              },
              Answer: [],
              RecTriggerAnswer: null,
              Recommendation: null
            },
            Q7: {
              question: {
                type: "bool",
                question: "Do you conduct regular security testing of your external network and services?",
                options: ["Yes", "No"]
              },
              Answer: null,
              RecTriggerAnswer: "No",
              Recommendation: "As part of a well maintained and secured network, regular security testing should always be incorporated.  Where no security testing has previosuly been conducted a complete manual security assessment can provide a detailed overview of your systems, the current state of their security and help guage your current security posture.  Once a secure baseline is established, regular security testing can be conducted on an ongoing basis to ensure your systems are secure and maintained against the latest emerging threats."
            },
          }
        },
        {
          name: "Secure Configuration",
          questionSet: {
            Q1: {
              question: {
                type: "bool",
                question: "Do you maintain a standard build process for all devices?",
                options: ["Yes", "No"]
              },
              Answer: null,
              RecTriggerAnswer: "No",
              Recommendation: "All devices intended for use within your organisation should undergo a standardised build process to ensure their initial setup maintains a secure baseline in line with all other devices in use.  This process should be reviewed and updated on a regular basis, and devices in use throughout your organisation should also be reviewed on a regular basis to ensure that they are maintained in line with the initially intended secure configuration.  The standardised build process can include options for securing accounts, removing unnecessary software, updating default settings and installing a standardised OS version."
            },
            Q2: {
              question: {
                type: "bool",
                question: "Do you maintain the security of your Mobile Devices through an MDM solution?",
                options: ["Yes", "No"]
              },
              Answer: null,
              RecTriggerAnswer: null,
              Recommendation: null
            },
            Q3: {
              question: {
                type: "bool",
                question: "Do you maintain a Mobile Device Management policy document?",
                options: ["Yes", "No"]
              },
              Answer: null,
              RecTriggerAnswer: "No",
              Recommendation: "For any organisation which makes use of mobile devices, for messaging, email or access to any company data and resources.  The security of these devices should be considered and managed in a similar mannar to the security of any other devices in use for your organisation.  This can be of particular importance when personal or BYOD's are allowed to access company data.  To ensure all devices which access your company data adhere to a suitable set of security requirements, it is recommended to setup a baseline set of requirements for your users mobile devices to abide by.  This should include password settings and device locking, ensuring that devices maintain a suitably supported operating system and that configuration options such as developer modes, or even rooting/jailbreaking are avoided."
            },
            Q4: {
              question: {
                type: "bool",
                question: "Do you review which devices can access your organisation's data on a regular basis?",
                options: ["Yes", "No"]
              },
              Answer: null,
              RecTriggerAnswer: "No",
              Recommendation: "The devices which are used by your organisation, whether company issued or personal are likely to undergo changes overtime.  These changes may result in the device straying away from the initially configured secure baseline.  Whether this is through user access permissions being updated, the configuration of the device being altered or the installed software varying.  As such, it is necessary to conduct a regular review of your devices, to verify the configuration and security of the device have not altered significantly to the point where vulnerabilities have been introduced into your organisation."
            },
            Q5: {
              question: {
                type: "multi",
                question: "Do you maintain regular backups of your systems, data, 365 and Cloud environments?",
                options: ["Systems", "Data", "Cloud"]
              },
              Answer: [],
              RecTriggerAnswer: null,
              Recommendation: null
            },
            Q6: {
              question: {
                type: "multi",
                question: "Do you conduct any regular security reviews against the settings and configuration of your assets, networks, cloud environments?",
                options: ["Assets", "Networks", "Cloud"]
              },
              Answer: [],
              RecTriggerAnswer: null,
              Recommendation: null
            },
          }
        },
        {
          name: "Security Update Management",
          questionSet: {
            Q1: {
              question: {
                type: "bool",
                question: "Do you have a process in place to ensure operating systems and software are kept up to date for all devices?",
                options: ["Yes", "No"]
              },
              Answer: null,
              RecTriggerAnswer: "No",
              Recommendation: "Vulnerabilities are often disclosed in both software and operating systems overtime, and are resolved through vendor supplied updated.  These updates are often associated with a severity level depending upon the nature of the vulnerability being resolved.  Attackers, often automate the exploitation of recently disclosed vulnerabilities and launch a non-targeted attack against any systems which may utilise the vulnerable system.  As such, it is important to ensure a strict patching policy is maintained and that vendor supplied patching are applied at the earlist available opportunity."
            },
            Q2: {
              question: {
                type: "multi",
                question: "Are updates applied automatically or manually?",
                options: ["Automatically", "Manually"]
              },
              Answer: []
            },
            Q3: {
              question: {
                type: "bool",
                question: "Do you have a patch managament solution in place?",
                options: ["Yes", "No"]
              },
              Answer: null,
              RecTriggerAnswer: null,
              Recommendation: null
            },
            Q4: {
              question: {
                type: "bool",
                question: "Do you conduct any regular security testing of devices to verify patch management?",
                options: ["Yes", "No"]
              },
              Answer: null,
              RecTriggerAnswer: "No",
              Recommendation: "Maintaining a strict patch management policy should be a standard process for any organisation, whether this is maintaind through manual processes or automation.  It can often be the case that any patch management solution will not capture all available patches which are released by the vendor.  This may be due to configuration changes which may need to be applied, older file versions not being removed from your systems, or software that has been installed and not captured as part of the regular patch management process.  Through a combination of these factors, missing patches can often be found in many devices and conducting a regular security assessment against your systems can ensure that any outdated systems and known vulneabilities are identified and resolved."
            },
          }
        },
        {
          name: "User Access Controls",
          questionSet: {
            Q1: {
              question: {
                type: "bool",
                question: "Do you maintain a process to create/edit/remove user accounts?",
                options: ["Yes", "No"]
              },
              Answer: null,
              RecTriggerAnswer: "No",
              Recommendation: "The user accounts in use throughout your organisation provide access to all your assets and data.  It is therefore important to ensure they are suitable secured, tracked and protected from potential compromise.  Whenever a new acount is created, the permissions of an existing account changed, or an old account removed, it is important to ensure this information is captured, logged and has been approved.  This ensures that each account in use within your organisation is securely maintained and logged, with only the relevent permissions assiged to the account in order for the user to carry out their tasks."
            },
            Q2: {
              question: {
                type: "bool",
                question: "Do you have an elevated approval process for the creation of administrator accounts?",
                options: ["Yes", "No"]
              },
              Answer: null,
              RecTriggerAnswer: "No",
              Recommendation: "By default any user account that is created should not be granted with administrator permissions.  As accounts such as this may have the ability to install additional software, execute privileged commands and alter the underlying configuration and operating system of the device, there issuance should be restricted and only provided when absolutely necessary.  It is likely that the standard users of your devices will never need administrator permissions once the devices have undergone an initial build process to suitable configure the device and install necessary tools.  Limiting the distribution of administrator accounts can also ensure a level of security and mitigation against a range of potential attacks, as any potential action the user may take will only execute with limited permissions."
            },
            Q3: {
              question: {
                type: "bool",
                question: "Do you maintain account separation for standard and admin users?",
                options: ["Yes", "No"]
              },
              Answer: null,
              RecTriggerAnswer: "No",
              Recommendation: "When establishing a user as an administrator, an important step to maintaining the security of the initial standard user account, is to ensure the administrator permissions are assigned to a seperate, secondary account.  This ensures that the standard user account is maintained for standard day-to-day use, such as opening documents, answering emails, browsing the internet etc.  When absolutely necessary, the administrator account can be used to authorise a particular task that requires the elevated permissions, however the administrator account should not be used to log into a standard workstation environment and used as a day-to-day account.  This process helps to ensure that the security of your accounts is maintained, and that if a potential security incident occurs for a given user, the impact will be mitigated by the use of your standard user accounts."
            },
            Q4: {
              question: {
                type: "bool",
                question: "Do you maintain policy documents for your user accounts, including Password Policy, Lockout Policy, User-Access Policy?",
                options: ["Yes", "No"]
              },
              Answer: null,
              RecTriggerAnswer: "No",
              Recommendation: "To ensure a consistent a secure configuration for all of your user accounts across a mixture of devices and platforms it is important to establish a baseline set of requirements for which all of your accounts can be adhered to.  The policy documents can help to guide technical controls to enforce settinngs as well as user password guidance on selecting and maintaining secure passwords.  Account compromise can be a common occurance and often is the result of an an insecure policy and a common password choice.  Establishing a secure set of minimum requirements can help to avoid this potential scenario for your organisation."
            },
            Q5: {
              question: {
                type: "bool",
                question: "Do you provide educational material to your users as a guide to and regarding the importance of selecting secure passwords?",
                options: ["Yes", "No"]
              },
              Answer: null,
              RecTriggerAnswer: "No",
              Recommendation: "Varied and regular training and reminders on the importance of security, the potential threats and examples of compromise can help to keep your users informed on the importance of security and help provide guidance on what forms a secure password and common patterns to avoid.  To encourage security recommendations can be made towards using a passphrase rather than a password, to utilise a password manager within your organisation and to enable MFA wherever available."
            },
            Q6: {
              question: {
                type: "bool",
                question: "Do you maintain a process to Create/Edit/Remove user accounts?",
                options: ["Yes", "No"]
              },
              Answer: null,
              RecTriggerAnswer: "No",
              Recommendation: "A regular security assessment against your user accounts can allow you to identify potential weaknesses in your account security policy, as well as the accounts themselves.  This can help to improve the existing policies and provide further guidance on steps to avoid repetitive and predictable patterns that are often found within passwords."
            },
            Q7: {
              question: {
                type: "bool",
                question: "Do you regularly conduct phishing awareness training?",
                options: ["Yes", "No"]
              },
              Answer: null,
              RecTriggerAnswer: "No",
              Recommendation: "In addition to user education on the importance of selecting secure credentials, your users should be well informed on the risks that organisations face from phishing attacks.  Phishing attacks are a common exploit route for many attackers which may lead to the compromise of your user accounts or devices.  This compromsie can often lead to ransomware, or the access sold to other attacker groups for a variety of purposes.  While many users will be aware of well known and obvious phishing scams, more advanced attacks with content and images used to replicate a legitimate source can often prove very effective.  Ensuring your users stay well informed through a mixture of training material and assessments can ensure your users, your accounts and your devices stay protected from phishing attacks."
            },
          }
        },
        {
          name: "Malware Protection",
          questionSet: {
            Q1: {
              question: {
                type: "bool",
                question: "Do your devices have anti-malware solution or Endpoint Detection & Response solutions?",
                options: ["Yes", "No"]
              },
              Answer: null,
              RecTriggerAnswer: "No",
              Recommendation: "As your devices are used on a day-to-day basis to access online content, there is the potential that malware will be introduced onto your device.  A suitably configured and up to date anti-malware solution can ensure your devices are protected from the most common types of malware, with solutions such as on-access file scanning preventing your users from accessing the files that represent a potential threat to your system.  A solution such as this can be setup as part of your initial standard device build, maintaining in line with your patching policies and reviewed on a regular basis to ensure that the system is identifiing and restricting access to known malicious files."
            },
            Q2: {
              question: {
                type: "text",
                question: "What antivirus, EDR or other protection solution is in place?",
              },
              Answer: null
            },
            Q3: {
              question: {
                type: "bool",
                question: "Do you regularly assess the security of your systems against security benchmarks?",
                options: ["Yes", "No"]
              },
              Answer: null,
              RecTriggerAnswer: "No",
              Recommendation: "A regular security assessment against your assets can help to identify any security best practices which are not being met, as well as highlight any vulneabilities within the configured system and installed software and operating system.  This can be conducted as both an automated security scanning assessment of your devices on a regular basis as well as a more detailed and thorough manual assessment conducted less regularly.  It is important that regular security assessments such as this are considered for all assets which are used within your organisation, including cloud services which can also be assessed against a set of security best practices."
            },
          }
        }
      ]
  },
  mutations: {
    setQuestionBlobs(state, newState) {
      console.log('storing state')
      state.questions = newState
    },
    setEmail(state, email) {
      console.log('setting email ' + email)
      state.email = email
    }
  },
  getters: {
    getQuestionBlobs(state) {
      return state.questions
    },
    getWholeBlob(state) {
      return state
    },
    getEmail(state) {
      return state.email
    }
  },
  plugins: [vuexLocalStorage.plugin]
})
